import { ChangeEvent, ForwardedRef, forwardRef } from 'react';
import { LabelPrimary } from '@components/label';
import { Textarea } from '@components/textarea';
import classNames from 'classnames';

import { InputMultiEmailProps } from './input-multi-email.type';

export const InputMultiEmail = forwardRef(
  (
    {
      id,
      label,
      optional,
      optionalLabel,
      placeholder,
      helperText,
      hasError,
      disabled,
      value,
      containerClassName,
      onChange,
      ...props
    }: InputMultiEmailProps,
    ref: ForwardedRef<HTMLTextAreaElement>
  ) => {
    const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
      onChange(e);
    };

    return (
      <div className={classNames('w-full', containerClassName)}>
        {label && (
          <LabelPrimary isBold className='mb-1' id={id}>
            {label}
            {optional && optionalLabel && <span className='text-secondary ml-1'>{optionalLabel}</span>}
          </LabelPrimary>
        )}

        <Textarea
          ref={ref}
          id={id}
          rows={3}
          type='text'
          value={value}
          hasError={hasError}
          onChange={handleChange}
          placeholder={placeholder}
          disabled={disabled}
          {...props}
        />

        {helperText && <p className='mt-1 text-xs text-secondary'>{helperText}</p>}
      </div>
    );
  }
);

InputMultiEmail.displayName = 'InputMultiEmail';
